module.exports = __webpack_public_path__ + "img/arrow-square-down.d7019625.svg";